import {Component, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {  CalendarOptions } from '@fullcalendar/core';

import {
  MEETING_TYPE_ADA,
  MEETING_TYPE_EXAM,
  MEETING_TYPE_ENTRANCE_EXAM,
  MEETING_TYPE_IDD_TRAINING, MEETING_TYPE_MEETING,
  MEETING_TYPE_NEW_AGENT_TRAINING, MEETING_TYPE_OTHER, MEETING_TYPE_TRAINING,
} from "../../../shared/services/dict.service";
import {MeetingService} from "../../../shared/services/meeting.service";
import {startWith, takeUntil} from "rxjs/operators";
import {Meeting} from "../../../shared/interface/meeting";
import {ReplaySubject} from "rxjs";
import {FilterService} from "../../../shared/services/filter.service";
import {FormBuilder, FormControl, FormGroup, NgForm} from "@angular/forms";
import {ListResponse} from "../../../shared/interface/response/list-response";
import { MatDialog} from "@angular/material/dialog";
import {MeetingDetailsViewDialogComponent} from "../meeting-details-view-dialog/meeting-details-view-dialog.component";
import {MeetingAddDialogComponent} from "../meeting-add-dialog/meeting-add-dialog.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import moment from "moment/moment";
import {co} from "@fullcalendar/core/internal-common";

interface Event {
  title: string;
  start: any;
  end: any;
  backgroundColor: any;
  textColor: any;
  extendedProps: any;
  subject: any;
  id: string;
}

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnDestroy, OnInit {
  @Input() dialogRef = false;
  @Input() disableFilters = false;
  @ViewChild('filtersForm') filtersForm: NgForm;
  calendarOptions: CalendarOptions;
  meetings: Meeting[] = [];
  events: Event[] = [];
  test = false;
  userPermissions: ReplaySubject<UserPermissions>;
  initialFilters: any;
  daysInMonth: number;
  firstWeekdayOfMonth: number;
  rows = 0;
  monthControl: FormControl;
  form: FormGroup;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  readonly MEETING_TYPE_EXAM = MEETING_TYPE_EXAM;
  readonly MEETING_TYPE_ENTRANCE_EXAM = MEETING_TYPE_ENTRANCE_EXAM;
  readonly MEETING_TYPES = [MEETING_TYPE_IDD_TRAINING, MEETING_TYPE_NEW_AGENT_TRAINING,
    MEETING_TYPE_ADA, MEETING_TYPE_TRAINING, MEETING_TYPE_MEETING,
    MEETING_TYPE_OTHER, MEETING_TYPE_NEW_AGENT_TRAINING];


  constructor(
    private fb: FormBuilder,
    private meetingService: MeetingService,
    private filterService: FilterService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private auth: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
) {
    const date = moment();
    date.startOf('month');
    this.form = fb.group({
      month: this.monthControl = fb.control(date),
    });
    this.userPermissions = auth.getUserPermissions();
    this.loadData();
    this.parseFilters();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  handleEventClick(info): void  {
    const dialogRef = this.dialog.open(MeetingDetailsViewDialogComponent, {
      width: '50%',
      maxHeight: '60vh',
      data: {meeting: info.event.id,
      dialogActive: true},
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadData();
    });
  }
  ngOnInit(): void {
    this.form.valueChanges
      .pipe(
        startWith(this.monthControl.value),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => {
        const val = this.monthControl.value;
        val.startOf('month');
        this.daysInMonth = val.daysInMonth();

        let weekday = val.weekday();
        if (weekday === 0) {
          weekday = 7;
        }

        this.firstWeekdayOfMonth = weekday;

        this.rows = Math.ceil((this.daysInMonth + this.firstWeekdayOfMonth - 1) / 7);
        this.loadData();
      });
  }

  add(): void {
    const dialogRef = this.dialog.open(MeetingAddDialogComponent, {
      width: '50%',
      maxHeight: '90vh',
      data: {   typeOnlyKeys: [MEETING_TYPE_IDD_TRAINING, MEETING_TYPE_NEW_AGENT_TRAINING, MEETING_TYPE_ADA,
          MEETING_TYPE_TRAINING, MEETING_TYPE_MEETING, MEETING_TYPE_OTHER]

      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadData();
    });
  }

  loadData(): void {
    this.test = false;
    const filters = {...this.initialFilters};
    filters.typeKey = [];
    filters.typeKey.push(MEETING_TYPE_IDD_TRAINING);
    filters.typeKey.push(MEETING_TYPE_NEW_AGENT_TRAINING);
    filters.typeKey.push(MEETING_TYPE_ADA);
    filters.typeKey.push(MEETING_TYPE_TRAINING);
    filters.typeKey.push(MEETING_TYPE_MEETING);
    filters.typeKey.push(MEETING_TYPE_OTHER);
    filters.month = this.monthControl.value;

    this.meetingService.loadNotCountedList(0, 9999999, filters);

    this.meetingService.meetingNotCountedListSubject
      .pipe(takeUntil(this.destroyed$))
      .subscribe((result: ListResponse<Meeting>) => {
        this.meetings = result.items;
        this.test = true;
      });

  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      in$insuranceCompany: 'int[]',
      gte$startsAt: 'date',
      lte$endsAt: 'date',
      in$status: 'int[]',
      in$examType: 'int[]',
      in$place: 'int[]',
      in$leader: 'int[]',
      address: 'string',
      state: 'int',
      type: 'int',
      room: 'int',
    }, filters);
  }

  filter(): void {
    this.loadData();
  }


  resetFilters(): void {
    this.filtersForm.resetForm();
    this.loadData();
  }

  getEvents(day: number): Meeting[] {
    const meetings = [];

    this.meetings.forEach((meeting: Meeting) => {
      const startsAtDate = moment(meeting.startsAt);
      const endAtDate = moment(meeting.endsAt);

      if ( moment(this.monthControl.value).month() === startsAtDate.month() &&
        moment(this.monthControl.value).month() === endAtDate.month() ) {
        if (startsAtDate.date() <= day && endAtDate.date() >= day) {
          meetings.push(meeting);
        }
      } else if ( moment(this.monthControl.value).month() === startsAtDate.month() &&
        moment(this.monthControl.value).month() !== endAtDate.month() ) {
        if (startsAtDate.date() <= day ) {
          meetings.push(meeting);
        }
      } else if ( moment(this.monthControl.value).month() !== startsAtDate.month() &&
        moment(this.monthControl.value).month() === endAtDate.month() ) {
        if ( endAtDate.date() >= day) {
          meetings.push(meeting);
        }
      } else if ( moment(this.monthControl.value).month() !== startsAtDate.month() &&
        moment(this.monthControl.value).month() !== endAtDate.month() ) {
          meetings.push(meeting);
      }
    });

    return meetings;
  }
  addMonth(): void {
    const month = this.monthControl.value;
    month.add(1, 'M');
    this.monthControl.setValue(month);
  }

  subtractMonth(): void {
    const month = this.monthControl.value;
    month.subtract(1, 'M');
    this.monthControl.setValue(month);
  }

  getMonthName(dateString: string): string {
    const date = new Date(dateString);
    const monthName = date.toLocaleString('pl-PL', { month: 'long' });
    const year = date.getFullYear();
    return `${monthName} ${year} `;
  }

}
